import router from '@/router'

export interface RedirectToLoginOptions {
  /**
   * On a guest page, reload instead of staying put. Use for actions taken
   * mid-test (e.g. submitting sensory) so the page can show the guest form
   * or the "guest access has ended" prompt instead of silently failing.
   */
  reloadOnGuestPage?: boolean
}

// Pages a guest can sign up on: a scanned test, or a contest's judge page.
export function isGuestPage(path = window.location.pathname): boolean {
  return /^\/(test\/[^/]+|contest\/\d+)\/?$/.test(path)
}

/**
 * Send a signed-out user to the login page. Guest pages handle their own 401
 * (they show the guest form when the panel allows guests), so they stay put.
 */
export function redirectToLogin(options: RedirectToLoginOptions = {}): void {
  if (isGuestPage()) {
    if (options.reloadOnGuestPage) {
      window.location.reload()
    }
    return
  }
  router.push('/login')
}
